import { useCallback, useEffect, useState } from 'react';
import { isBrowser } from '@root/utils/browser';
import { DESKTOP_BREAKPOINT, TABLET_BREAKPOINT } from '@root/utils/constants';

import { UseScreenRecognitionHook } from './model';

const useScreenRecognition: UseScreenRecognitionHook = () => {
  const browserAvaliable = isBrowser();
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isNotMobile, setIsNotMobile] = useState(false);

  const handleResize = useCallback(() => {
    const width = browserAvaliable && window.innerWidth;

    setIsMobile(width < TABLET_BREAKPOINT);
    setIsNotMobile(width >= TABLET_BREAKPOINT);
    setIsTablet(width >= TABLET_BREAKPOINT && width < DESKTOP_BREAKPOINT);
    setIsDesktop(width >= DESKTOP_BREAKPOINT);
  }, [browserAvaliable]);

  useEffect(() => {
    handleResize();

    if (browserAvaliable) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (browserAvaliable) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [browserAvaliable, handleResize]);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isNotMobile,
  };
};

export default useScreenRecognition;
